export default __webpack_public_path__ + "static/media/introback2.30148855.png";